import ADSENSE_CONFIG from "@/config/adsense";

/**
 * Load AdSense only in production builds.
 * Dev uses Vite without the adsbygoogle script (see vite.config adsense-prod-only).
 * This is a client-side fallback if the HTML shell somehow lacks the tag.
 */
export function loadAdSenseScript(): void {
  if (!import.meta.env.PROD) return;
  if (typeof document === "undefined") return;
  if (!ADSENSE_CONFIG.isConfigured()) return;
  if (document.querySelector('script[src*="adsbygoogle.js"]')) return;

  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = "https://pagead2.googlesyndication.com";
  document.head.appendChild(link);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CONFIG.CLIENT_ID}`;
  script.crossOrigin = "anonymous";
  document.head.appendChild(script);
}
